import { useMutation } from '@apollo/client';
import { ConsumerCreate } from '@bakerweb/models';
import { toast } from 'react-toastify';
import { CREATE_CONSUMER_MUTATION } from '../graphql/mutations/createConsumer';

export function useCreateConsumer() {
  const [createConsumerMutation, { data, loading, error }] = useMutation(CREATE_CONSUMER_MUTATION);

  const createConsumer = async (consumerData: ConsumerCreate) => {
    try {
      const response = await createConsumerMutation({
        variables: { consumerCreateDto: consumerData }
      });
      toast.success('Your inquiry is on the way!');
      return response;
    } catch (err) {
      toast.error(`There was an error sending your request. Please try again.`);
      return null;
    }
  };

  return { createConsumer, data, loading, error };
}
